import React, { useEffect, useState } from "react";

const InlineSvgIcon = ({ src, ...props }) => {
  const [svgContent, setSvgContent] = useState(null);

  useEffect(() => {
    fetch(src)
      .then((response) => response.text())
      .then(setSvgContent)
      .catch(console.error);
  }, [src]);

  return svgContent ? (
    <div {...props} dangerouslySetInnerHTML={{ __html: svgContent }} />
  ) : null;
};

export default InlineSvgIcon;
